// extracted by mini-css-extract-plugin
export var aboveInput = "_lr-0";
export var actionButton = "_lr-5";
export var actionButtonContainer = "_lr-1";
export var actionIcon = "_lr-6";
export var aiInfoContainer = "_lr-2";
export var attachmentWrapper = "_lr-7";
export var bold = "_lr-3";
export var checkIcon = "_lr-8";
export var clickingRecipientBar = "_lr-11";
export var commentThreadSwitch = "_lr-a";
export var draftImage = "_lr-b";
export var draftImageContainer = "_lr-c";
export var draftImages = "_lr-e";
export var editButton = "_lr-g";
export var editor = "_lr-f";
export var editorContainer = "_lr-y";
export var editorErrorTooltipWrapper = "_lr-9";
export var headerDivider = "_lr-h";
export var icon = "_lr-i";
export var info = "_lr-j";
export var internal = "_lr-n";
export var internalDivider = "_lr-k";
export var internalMessage = "_lr-l";
export var messageInputCard = "_lr-m";
export var messageInputForm = "_lr-o";
export var messageInputFormInternal = "_lr-p";
export var options = "_lr-q";
export var publicMessageCustomer = "_lr-s";
export var publicMessageMerchant = "_lr-r";
export var removeImageButton = "_lr-d";
export var replyButtons = "_lr-t";
export var showSignatureButton = "_lr-u";
export var spinner = "_lr-v";
export var verticalButtonDivider = "_lr-4";
export var visibilitySelector = "_lr-w";
export var warning = "_lr-x";
export var wrappingText = "_lr-z";
export var writingInternalNoteTopBorder = "_lr-10";